import { useEffect, useRef } from 'react';
import Modal from './Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faCircleQuestion, faCircleCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import './ConfirmModal.scss';

// Default icon per variant — a caller can pass its own (e.g. a logout icon) via `icon`.
const VARIANT_ICONS = {
	danger:  faTriangleExclamation,
	primary: faCircleQuestion,
	success: faCircleCheck,
};

// Compact centered confirm dialog: colored icon badge, title + description, two full-width
// buttons. The confirm button gets focus on open, so Enter confirms and Escape cancels.
const ConfirmModal = ({
	id,
	title = 'Confirmer cette action ?',
	description,
	confirmLabel = 'Confirmer',
	cancelLabel = 'Annuler',
	confirmVariant = 'danger',
	icon,
	show,
	onClose,
	onConfirm,
	isLoading = false,
}) => {
	const variant = VARIANT_ICONS[confirmVariant] ? confirmVariant : 'danger';
	const confirmRef = useRef(null);

	// react-modal mounts the dialog a beat after `show` flips — focus on the next tick
	useEffect(() => {
		if (!show) return undefined;
		const timer = setTimeout(() => confirmRef.current?.focus(), 50);
		return () => clearTimeout(timer);
	}, [show]);

	return (
		<Modal
			id={id}
			show={show}
			onClose={onClose}
			classSize="modal-dialog-centered confirm-modal"
			dialogStyle={{ maxWidth: 400 }}
		>
			<button type="button" className="confirm-modal__close" onClick={onClose} aria-label={cancelLabel}>
				<FontAwesomeIcon icon={faXmark} />
			</button>

			<div className={`confirm-modal__icon confirm-modal__icon--${variant}`}>
				<FontAwesomeIcon icon={icon || VARIANT_ICONS[variant]} />
			</div>

			<h5 className="confirm-modal__title">{title}</h5>
			{description && <div className="confirm-modal__desc">{description}</div>}

			<div className="confirm-modal__actions">
				<button type="button" className="modal-btn-secondary" onClick={onClose} disabled={isLoading}>
					{cancelLabel}
				</button>
				<button
					ref={confirmRef}
					type="button"
					className={`modal-btn-${variant}`}
					onClick={onConfirm}
					disabled={isLoading}
				>
					{isLoading && <span className="spinner-border spinner-border-sm text-white" />}
					{confirmLabel}
				</button>
			</div>
		</Modal>
	);
};

export default ConfirmModal;
